module.exports = __webpack_public_path__ + "static/media/required-reading.12599c59.md";